import { animate } from '@play-co/timestep-core/ui';

// EXPERIMENTAL - wrap all magic lamps animation in a single group
// to allow canceling all at once, if the popup is closed while playing animations

/**
 * Animate wrapper for magicLamps feature, default to group 'magicLamps'
 */
export async function magicLampsAnim(
  target: object,
  props: Record<string, number>,
  duration: number,
  ease?: (t: number) => number,
) {
  // Play the animation
  return animate(target, 'magicLamps').now(props, duration, ease).toPromise();
}

/**
 * Animate wrapper for non-view properties, default to group 'magicLamps'
 */
export async function magicLampsAnimEx(
  target: object,
  props: Record<string, number>,
  duration: number,
  ease?: (t: number) => number,
) {
  // Cast target to Record<string, number> to avoid type error
  const t = target as Record<string, number>;

  // Store starting values of target properties
  const startingProps: Record<string, number> = {};
  for (let key in props) {
    if (t[key] === undefined) {
      console.warn(`Target does not have property ${key}`);
      continue;
    }
    startingProps[key] = t[key];
  }

  // Get starting properties entries
  const startingPropsEntries = Object.entries(startingProps);

  // Play the animation using a dummy target that updates the actual target properties,
  // as workaround for animating custom properties
  return animate({}, 'magicLamps')
    .now(
      (_, value) => {
        for (const [key, val] of startingPropsEntries) {
          t[key] = val + (props[key] - val) * value;
        }
      },
      duration,
      ease,
    )
    .toPromise();
}

/**
 * Dummy animation for creating a cancelable delay, default to group 'magicLamps'
 */
export function magicLampsAnimDelay(ms: number) {
  return animate({}, 'magicLamps').now({}, ms).toPromise();
}

/**
 * Clear all animations in group 'magicLamps'
 */
export function magicLampsAnimClear() {
  animate.getGroup('magicLamps')?.clear();
}
